module.exports = __webpack_public_path__ + "img/yom-hatzmaut-2018.a42af4ff.jpg";